import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import closeIcon from '../../../images/close-icon.svg';
import banner from '../../../images/error-modal-banner.png';
import * as Styled from './ErrorModalStyles';
import auth from '../../services/authentication';
import useObservable from '../../hooks/useObservable';
import SubscriptionsStore from '../../xstores/subscriptions';
import {EmojiWrapper} from '../EmojiWrapper';

interface logDataProps{
  // following 5 items are collected by default
  // this info alone cannot be tied to a particular user
  location: string,                 // in app path
  userAgent: string,                // user browser and device info
  time: string,                     // time of error in UTC string
  error: object | string,           // console error when the app was about to crash or API failed
  errorInfo: null | object,         // React framework specific error
  // the following are collected only if the user agrees
  // by ticking the checkbox in the error window
  query: string | string[] | null,  // Search query at the time, if applicable
  subscriptions: any[] | null,      // User subscriptions
  account: any | null,              // User account info
  token: string | null,             // User token
}

const ErrorModal = ({ error, errorInfo, onDismiss }:any) => {
  const [isOpen, setIsOpen] = useState(false);
  const [agreeLogs, setAgreeLogs] = useState(false);
  const location = useLocation();
  const querySubscriptions = useObservable(SubscriptionsStore.querySubscriptions$, []);
  const onClose = () => {
    setIsOpen(false);
    onDismiss && onDismiss();
  }

  const toggleLogs = () => {
    setAgreeLogs(!agreeLogs);
  }

  const locationActions:any = {
    '/searchresults': () => {
      window.location.assign('/searchportal');
    },
    /*'/bookmarks': () => {
      setIsOpen(false);
      onDismiss()
    },*/
    '/activity': () => {
      window.location.reload();
      setIsOpen(false);
      onDismiss();
    }
  }

  const onSubmit = () => {
    let query = null;
    if (location.search) {
      query = queryString.parse(location.search).q;
    }
    const logData:logDataProps = {
      location: location.pathname,
      userAgent: navigator.userAgent,
      time: new Date().toUTCString(),
      error,
      errorInfo: errorInfo || null,
      query: null,
      subscriptions: null,
      account: null,
      token: null,
    }
    if (agreeLogs) {
      logData.subscriptions = querySubscriptions;
      logData.query = query;
      logData.account = auth.getUserData();
      logData.token = auth.getToken();
    }
    if (locationActions[location.pathname]) {
      locationActions[location.pathname]();
    } else {
      window.location.reload();
    }
  }

  useEffect(() => {
    if (error) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [error]);

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      size="lg"
      contentClassName='ModalContent'
      dialogClassName='ModalDialog'
    >
      <Styled.ModalBody>
        <Styled.ModalClose onClick={onClose} className='HeaderBtn'>
          <Styled.StyledImg src={closeIcon} alt='Close' />
        </Styled.ModalClose>
        <Styled.Container>
          <Styled.Banner src={banner} />
          <Styled.Title>
            Oh no! Our bad <EmojiWrapper>&#128547;</EmojiWrapper>
          </Styled.Title>
          <Styled.Paragraph>
            We’re not exactly sure what happened, but our servers say something is wrong. Please don’t tell our boss...
          </Styled.Paragraph>
          <Styled.ModalBtn onClick={onSubmit}>
            Try again
          </Styled.ModalBtn>
          <Form.Group className="mb-3 mt-5 w-100" controlId="formBasicCheckbox">
            <Styled.Checkbox
              onChange={toggleLogs}
              checked={agreeLogs}
              type="checkbox"
              label="Help us fix this by sending us your logs"
            />
          </Form.Group>
        </Styled.Container>
      </Styled.ModalBody>
    </Modal>
  )
}

export default ErrorModal;